import React from 'react';

export default function TextInput({
    id,
    label,
    placeholder,
    required = false,
    value = "",
    onChange,
    disabled = false,
    helper = '',
    error = '',
}) {
    return (
        <div className="w-full">
            <label htmlFor={id} className={`block mb-2 font-medium text-gray-900 ${error ? 'text-red-700' : ''}`}>{`${label} ${required ? "*" : ""}`}</label>
            <input
              type="text"
              id={id}
              className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 ${disabled ? 'cursor-not-allowed' : ''} ${error ? 'border-red-500 text-red-900 placeholder-red-700' : ''}`}
              placeholder={placeholder}
              required={required}
              value={value}
              onChange={e => onChange(e.target.value)}
              disabled={disabled}
            />
            <p id={`helper-${id}`} className="mt-2 text-sm text-gray-600">{helper}</p>
            <p id={`error-${id}`} className="mt-2 text-sm text-red-600">{error}</p>
            { required && !value && <p id={`required-${id}`} className="mt-2 text-sm text-red-600">Champ obligatoire.</p>}
        </div>
    );
};
